import ControlBar from './ControlBar'
export default ControlBar


// WEBPACK FOOTER //
// ./src/modules/ControlBar/index.js